/**
 * Key: Netsuite Internal ID
 * Value: Name
 */
export const warehousesForApparel = {
  166: '8 Project MP',
  164: 'Aerre MP',
  73: 'Alessia MP',
  192: 'Alisped MP',
  68: 'Artigianaitalia MP',
  223: 'Bea MP',
  169: 'Bonfanti MP',
  72: 'Capelli MP',
  167: 'Colletti MP',
  71: 'Confitex MP',
  86: 'Department of Leather Technology MP',
  69: 'Edesim MP',
  242: 'Elata MP',
  271: 'Fun Factory MP',
  168: 'Gaen MP',
  165: 'Galfashion MP',
  204: 'Gommus MP',
  256: 'GruppoEffe MP',
  78: 'Ilari MP',
  74: 'Italproduzioni MP',
  190: 'La Sartoria MP',
  219: 'Landi MP',
  203: 'Lorenzi MP',
  202: 'Luca Renzi MP',
  262: 'Luravi MP',
  161: 'Marini MP',
  76: 'Mauron MP',
  207: 'Mavico MP',
  88: 'MG Creation MP',
  163: 'MGT MP',
  162: 'Nick Bronson MP',
  270: 'PM FASHION MP',
  70: 'Prima MP',
  170: 'Roberto Guerrini MP',
  272: 'Scuderi MP',
  208: 'Tesma MP',
  75: 'Ufficio MP',
}

export const warehousesDictionary = {
  /**
   * 2: FIEGE 00
   * 3: FIEGE 03
   * 4: FIEGE 04
   */
  fiege: ['2', '3', '4'],
  /**
   * 174: FLI 00
   * 176: FLI 02
   * 177: FLI 03
   */
  fli: ['174', '176', '177'],
}
